import request from "@/service";

/* 版本列表 */
export function getVersionPage(params) {
  return request({
    url: `/sys/sys/version/page`,
    method: "get",
    params
  });
}

/* 版本列表 */
export function versionInfo(data) {
  return request({
    url: `/sys/sys/version/info/${data}`,
    method: "get"
  });
}

/* 新增版本 */
export function versionSave(data) {
  return request({
    url: `/sys/sys/version/save`,
    method: "post",
    data
  });
}

/* 更新版本 */
export function versionUpdate(data) {
  return request({
    url: `/sys/sys/version/update`,
    method: "put",
    data
  });
}

/* 上下线 */
export function versionPublish(data) {
  return request({
    url: `/sys/sys/version/publish`,
    method: "put",
    data
  });
}

/* 批量删除版本 */
export function versionDelete(data) {
  return request({
    url: `/sys/sys/version/delete`,
    method: "delete",
    data
  });
}
